<template>
  <div v-if="isLoading" class="overlay-loading">
    <div class="loader"></div>
  </div>
</template>

<script>
import { inject, computed } from "vue";

export default {
  name: "GlobalLoading",
  setup() {
    const isLoadingRef = inject("isLoading");
    const isLoading = computed(() => isLoadingRef?.value ?? false);
    return { isLoading };
  },
};
</script>

<style scoped>
/* ===== Full-Screen Overlay ===== */
.overlay-loading {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999999 !important; /* أعلى حاجة */
}

/* ===== Spinner ===== */
.loader {
  width: 60px;
  height: 60px;
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(var(--primary-color), var(--primary-color));
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
